import { 
    ACTUALIZAR_LIST_DOCUMENTO,
    AGREGAR_DOCUMENTO,
    MODIFICAR_DOCUMENTO,
  } from "./documentosActions";

  const documentoReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_DOCUMENTO: {
            return {
                ...state,
                documentosList: action.payload
            }
        };

        case AGREGAR_DOCUMENTO:{
            return {
                 ...state,
                 documentosList: [action.payload, ...state.documentosList]
             }
         };

         case MODIFICAR_DOCUMENTO: {
            return {
                ...state,
                documentosList: state.documentosList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };
        
        default:
            return state;

    }
  }

  export default documentoReducer;